export default __webpack_public_path__ + "static/media/avatar_95.58622fb0.png";